<template>
    <div class="privacy-agreement">
      

        <div class="privacy-main" v-html="loanAgreement.protocolContent"></div>
    </div>
</template>

<script>
import { setTitle } from "@/utils/bridge";
import sensors from "sa-sdk-javascript";

/* 多个协议跳转同一个链接  <div class="privacy-title">{{ loanAgreement.protocolName }}</div>
 productId   标的code
 protocolType	协议类型	
            PROTOCOL_SIGN_SHUZI_USER_USE(15, "电子签名数字证书用户使用须知"),
            PROTOCOL_SIGN_SHUZI_USER_CONFIRM(16, "电子签名数字证书用户申请确认函"),
            PROTOCOL_TYPE_FENGXIAN(8, "风险揭示书"),
            PROTOCOL_TYPE_CHENGNUOSHU(18, "出借人承诺书"),
            PROTOCOL_TYPE_SHOUQUAN(9, "出借人授权委托书"),
            PROTOCOL_TYPE_CHUJIE(1, "出借信息咨询和服务协议"),
            PROTOCOL_TYPE_JIEKUAN(3, "借款协议模板"); 
 */
export default {
    data() {
        return {
            loanAgreement: {}
        };
    },
    created() {
        let params = this.$route.query;
        const { token, productId, protocolType } = params;
        this.token = decodeURIComponent(token || "");
        setTimeout(() => {
            if (protocolType === "8") {
                setTitle("风险揭示书");
                document.title = "风险揭示书";
            }
            if (protocolType === "3") {
                setTitle("借款协议");
                document.title = "借款协议";
            }
        }, 500);
        this.getPrototol(productId, protocolType, token);
    },
    mounted() {
        sensors.track("TMLoanAgreement");
    },
    methods: {
        getPrototol: function(id, type, token) {
            let self = this;
            this.$request({
                method: "get",
                url: `/h5/protocol/productPrototol?productId=${id}&protocolType=${type}&token=${token}`
                /*  url: `/h5/protocol/productPrototol?productId=300027944578362&protocolType=8` */
            })
                .then(res => {
                    const { code, msg, data } = res;
                    self.loanAgreement = data;
                })
                .catch(err => {
                    this.$toast(err);
                });
        }
    }
};
</script>
<style lang="less" scoped>
.privacy-agreement {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 16px;
    background: #fff;
    overflow-x: hidden;
    .privacy-title {
        text-align: center;
        display: block;
        width: 100%;
        font-size: 15px;
        color: #333333;
        margin-bottom: 18px;
        line-height: 20px;
    }
    .privacy-main {
        width: 100%;
        box-sizing: border-box;
        p {
            word-break: break-all;
            text-indent: 30px !important;
        }
    }
}
</style>
